import { getCountryAlpha3, getCountryAlpha2, LangCountries, SelectItem } from "../lib/countries";

export function getAlpha2(countries: LangCountries): SelectItem[] {
  return getCountryAlpha2(countries);
}

export function getAlpha3(countries: LangCountries): SelectItem[] {
  return getCountryAlpha3(countries);
}
